import React from "react";
import { FuelingSummaryDTO } from "../dtos/FuelingSummaryDTO";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import NumberFormatter from "features/shared/components/formatters/NumberFormatter";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import InfoItemMobile from "features/shared/components/infoItem/InfoItemMobile";
import RoundButton from "features/shared/components/buttons/RoundButton";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { useTranslation } from "react-i18next";

type Props = {
  summary: FuelingSummaryDTO;
  commodityDetail: CommodityDetail;
};

const FuelingMonthSummary = ({ summary, commodityDetail }: Props) => {
  // transaltions
  const tLabels = useTranslation("fueling\\fueling").t;

  // sub-renders
  const renderPrice = () => {
    if (summary.totalAmount && summary.amountCurrency) {
      return (
        <PriceFormatter
          amount={summary.totalAmount}
          currency={summary.amountCurrency}
        />
      );
    } else {
      return <>-</>
    }
  };

  const renderMonth = () => { 
    return (
      <DateFormatter
        date={new Date(summary.year!, summary.month! - 1, 1)}
        formatOptions={{ month: "long" }}
      />
    );
  }

  const renderFueling = () => { 
    return (
    <span>
        <NumberFormatter amount={summary.fuelingSum!} decimalPlaces={3} />
        <span className="d-sm-none small"> {summary.fuelingUnit}</span>
      </span>
    );
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm text-truncate">
            {renderMonth()}
          </div>
          <div className="col-sm text-sm-center">
            <InfoItemMobile
              title={tLabels(`fuelingMonthSummaryHeader.fuelingSum.${commodityDetail}`) + ":"}
              value={renderFueling()}
              hideTitleOn="sm"
              valueClassName="mr-auto mr-sm-0"
            />
          </div>
          <div className="col-sm text-sm-center">
            <InfoItemMobile
              title={tLabels(`fuelingMonthSummaryHeader.fuelingCount.${commodityDetail}`) + ":"}
              value={`${summary.fuelingCount}`}
              hideTitleOn="sm"
              valueClassName="mr-auto mr-sm-0"
            />
          </div>
          <div className="col-sm text-sm-center">
            <InfoItemMobile
              title={tLabels("fuelingMonthSummaryHeader.totalAmount") + ":"}
              value={renderPrice()}
              hideTitleOn="sm"
              valueClassName="mr-auto mr-sm-0"
            />
          </div>
        </div>
      </div>
      <div className="col-auto pl-3">
        <RoundButton 
          to={`charging-history/${summary.year}/${summary.month}`}
          asLink
        />
      </div>
    </div>
  );
};

export default FuelingMonthSummary;
